<div *ngIf="!loading">
  <div class="booble-backdrop">
    <div class="xp-modal xp-modal-cadastro">
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
      >
        <div class="modal-content">
          <div class="modal-dialog-scrollable-general">
            <div class="modal-header">
              <div class="header-title">
                <h4 class="m-0 title-modal">Anexar documentos</h4>
                <div class="ml-3 chip">
                  <p class="m-0 order-type">
                    {{
                      boobleModalData?.remmitanceType == "INBOUND"
                        ? "Receber dinheiro"
                        : "Envio de dinheiro"
                    }}
                  </p>
                </div>
              </div>
              <div (click)="closeModal()" class="close-icon tappable">
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>

            <div class="modal-body">
              <div class="">
                <div
                  *ngIf="boobleModalData?.remmitanceType == 'INBOUND'"
                  class="box-order"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Número:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.id }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Moeda: &nbsp;
                        <span class="value">
                          <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                          ><span class="ml-2">{{
                            this.currency?.description
                          }}</span>
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Valor de destino:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.currency?.description }}
                          {{ this.boobleModalData?.amount | amountPipe }}</span
                        ></span
                      ><br /><br />

                      <span class="p-text-grey">
                        Modalidade:&nbsp;
                        <span class="value">{{
                          getModalityText(this.boobleModalData?.modality)
                        }}</span></span
                      ><br /><br />

                      <span class="p-text-grey">
                        Número do boleto:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.slipCode }}
                        </span></span
                      ><br /><br />
                    </div>

                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Origem:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.orderSource }}
                        </span></span
                      ><br /><br />

                      <span class="p-text-grey"
                        >Data de criação: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.createdDate
                            | date : "dd/MM/yyyy"
                        }}</span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Finalidade:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.finality?.description }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Número do contrato:&nbsp;
                        <span
                          *ngIf="this.boobleModalData?.contractSettlementNumber"
                          class="value"
                          >{{
                            this.boobleModalData?.contractSettlementNumber
                          }} </span
                        ><span
                          *ngIf="
                            this.boobleModalData?.orderSettlement
                              ?.contractSettlementNumber
                          "
                          class="value"
                          >{{
                            this.boobleModalData?.orderSettlement
                              ?.contractSettlementNumber
                          }}
                        </span></span
                      ><br /><br />
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-center"
                    *ngIf="showReadMore"
                  >
                    <span
                      (click)="
                        !showReadMore
                          ? (showReadMore = true)
                          : (showReadMore = false)
                      "
                      class="view-more"
                      >{{ showReadMore ? "Ver mais " : "Ver menos" }}</span
                    >
                  </div>
                  <div [class]="showReadMore ? 'd-none' : 'd-block'">
                    <h4 class="mg-bottom-32 mg-top-8 title-generic">
                      Dados do cliente
                    </h4>
                    <div
                      class="row"
                      *ngIf="this.boobleModalData?.corporateAccount"
                    >
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.corporateAccount
                                ?.companyName
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >CNPJ: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.corporateAccount?.cnpj
                              | mask : "AA.AAA.AAA/AAAA-00"
                          }}</span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Telefone:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.corporateAccount?.users[0]
                                ?.phoneNumber | mask : "(00) 00000-0000"
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Faturamento anual:&nbsp;
                          <span class="value">
                            {{
                              this.boobleModalData?.corporateAccount
                                ?.annualBilling | brl
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-12">
                        <span class="p-text-grey">
                          E-mail:&nbsp;
                          <span class="value"
                            >{{
                              boobleModalData?.corporateAccount?.users[0]
                                .emailList ||
                                boobleModalData?.corporateAccount?.users[0]
                                  .email
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                    </div>

                    <div
                      class="row"
                      *ngIf="this.boobleModalData?.individualAccount"
                    >
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value">
                            {{ this.boobleModalData?.individualAccount?.name }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >CPF: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.individualAccount?.cpf
                              | mask : "000.000.000-00"
                          }}</span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          E-mail:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.individualAccount?.contact
                                ?.email
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Telefone:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.individualAccount?.contact
                                ?.phone | mask : "(00) 00000-0000"
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                    </div>

                    <h4 class="mg-bottom-32 mg-top-8 title-generic">
                      Dados do pagador
                    </h4>
                    <div class="row">
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value"
                            >{{ this.boobleModalData?.sender?.companyName }}
                          </span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          País:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.sender?.country?.description
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="!showReadMore"
                    class="d-flex justify-content-center"
                  >
                    <span
                      (click)="
                        !showReadMore
                          ? (showReadMore = true)
                          : (showReadMore = false)
                      "
                      class="view-more"
                      >{{ showReadMore ? "Ver mais " : "Ver menos" }}</span
                    >
                  </div>
                </div>

                <div
                  *ngIf="boobleModalData.remmitanceType === 'OUTBOUND'"
                  class="box-order"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Número:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.id }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey"
                        >Moeda: &nbsp;
                        <span class="value">
                          <mat-icon [svgIcon]="this.currency?.icon"></mat-icon
                          ><span class="ml-2">{{
                            this.currency?.description
                          }}</span>
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Valor de destino:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.currency?.description }}
                          {{ this.boobleModalData?.amount | amountPipe }}</span
                        ></span
                      ><br /><br />

                      <span class="p-text-grey">
                        Modalidade:&nbsp;
                        <span class="value">{{
                          getModalityText(this.boobleModalData?.modality)
                        }}</span></span
                      ><br /><br />

                      <span class="p-text-grey">
                        Número do boleto:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.slipCode }}
                        </span></span
                      ><br /><br />
                    </div>

                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Origem:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.orderSource }}
                        </span></span
                      ><br /><br />

                      <span class="p-text-grey"
                        >Data de criação: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.createdDate
                            | date : "dd/MM/yyyy"
                        }}</span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Finalidade:&nbsp;
                        <span class="value"
                          >{{ this.boobleModalData?.finality?.description }}
                        </span></span
                      ><br /><br />
                      <span class="p-text-grey">
                        Número do contrato:&nbsp;
                        <span
                          *ngIf="this.boobleModalData?.contractSettlementNumber"
                          class="value"
                          >{{
                            this.boobleModalData?.contractSettlementNumber
                          }} </span
                        ><span
                          *ngIf="
                            this.boobleModalData?.orderSettlement
                              ?.contractSettlementNumber
                          "
                          class="value"
                          >{{
                            this.boobleModalData?.orderSettlement
                              ?.contractSettlementNumber
                          }}
                        </span></span
                      ><br /><br />
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-center"
                    *ngIf="showReadMore"
                  >
                    <span
                      (click)="
                        !showReadMore
                          ? (showReadMore = true)
                          : (showReadMore = false)
                      "
                      class="view-more"
                      >{{ showReadMore ? "Ver mais " : "Ver menos" }}</span
                    >
                  </div>

                  <div [class]="showReadMore ? 'd-none' : 'd-block'">
                    <h4 class="mg-bottom-32 mg-top-8 title-generic">
                      Dados do cliente
                    </h4>
                    <div
                      class="row"
                      *ngIf="this.boobleModalData?.corporateAccount"
                    >
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.corporateAccount
                                ?.companyName
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >CNPJ: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.corporateAccount?.cnpj
                              | mask : "AA.AAA.AAA/AAAA-00"
                          }}</span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Telefone:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.corporateAccount?.users[0]
                                ?.phoneNumber | mask : "(00) 00000-0000"
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Faturamento anual:&nbsp;
                          <span class="value">
                            {{
                              this.boobleModalData?.corporateAccount
                                ?.annualBilling | brl
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-12">
                        <span class="p-text-grey">
                          E-mail:&nbsp;
                          <span class="value"
                            >{{
                              boobleModalData?.corporateAccount?.users[0]
                                .emailList ||
                                boobleModalData?.corporateAccount?.users[0]
                                  .email
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                    </div>

                    <div
                      class="row"
                      *ngIf="this.boobleModalData?.individualAccount"
                    >
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value">
                            {{ this.boobleModalData?.individualAccount?.name }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >CPF: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.individualAccount?.cpf
                              | mask : "000.000.000-00"
                          }}</span></span
                        ><br /><br />
                      </div>
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          E-mail:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.individualAccount?.contact
                                ?.email
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey">
                          Telefone:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.individualAccount?.contact
                                ?.phone | mask : "(00) 00000-0000"
                            }}
                          </span></span
                        ><br /><br />
                      </div>
                    </div>

                    <h4 class="mg-bottom-32 mg-top-8 title-generic">
                      Dados do recebedor
                    </h4>
                    <div class="row">
                      <div class="col-md-6">
                        <span class="p-text-grey">
                          Nome:&nbsp;
                          <span class="value"
                            >{{ this.boobleModalData?.receiver?.name }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >Banco: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.bank || this.boobleModalData?.receiver?.bankName
                          }}</span></span
                        ><br /><br />
                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.number ||
                            this.boobleModalData?.receiver?.account
                          "
                        >
                          <span class="p-text-grey"
                            >Conta: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.number ||
                                this.boobleModalData?.receiver?.account
                            }}</span></span
                          ><br /><br />
                        </ng-container>
                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.institutionNumber
                          "
                        >
                          <span class="p-text-grey"
                            >Institution Number: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.institutionNumber
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.transit
                          "
                        >
                          <span class="p-text-grey"
                            >Transit: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.transit
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.address
                          "
                        >
                          <span class="p-text-grey"
                            >Address: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.address
                            }}</span></span
                          ><br /><br />
                        </ng-container>
                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount?.cbu
                          "
                        >
                          <span class="p-text-grey"
                            >CBU: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.cbu
                            }}</span></span
                          ><br /><br />
                        </ng-container>
                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.sortCode
                          "
                        >
                          <span class="p-text-grey"
                            >Sort Code: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.sortCode
                            }}</span></span
                          ><br /><br />
                        </ng-container>
                      </div>

                      <div class="col-md-6">
                        <span class="p-text-grey">
                          País:&nbsp;
                          <span class="value"
                            >{{
                              this.boobleModalData?.receiver?.country
                                ?.description
                            }}
                          </span></span
                        ><br /><br />
                        <span class="p-text-grey"
                          >Código SWIFT: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.swift || this.boobleModalData?.receiver?.swift
                          }}</span></span
                        ><br /><br />
                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount?.aba
                          "
                        >
                          <span class="p-text-grey"
                            >ABA: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.aba
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.iban
                          "
                        >
                          <span class="p-text-grey"
                            >IBAN: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.iban
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.cable
                          "
                        >
                          <span class="p-text-grey"
                            >Cable: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.cable
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount?.blz
                          "
                        >
                          <span class="p-text-grey"
                            >BLZ: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.blz
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount?.fcc
                          "
                        >
                          <span class="p-text-grey"
                            >FFC: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.fcc
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount
                              ?.cuit
                          "
                        >
                          <span class="p-text-grey"
                            >CUIT: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.cuit
                            }}</span></span
                          ><br /><br />
                        </ng-container>

                        <ng-container
                          *ngIf="
                            this.boobleModalData?.receiver?.receiverAccount?.bsb
                          "
                        >
                          <span class="p-text-grey"
                            >BSB: &nbsp;
                            <span class="value">{{
                              this.boobleModalData?.receiver?.receiverAccount
                                ?.bsb
                            }}</span></span
                          ><br /><br />
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="!showReadMore"
                    class="d-flex justify-content-center"
                  >
                    <span
                      (click)="
                        !showReadMore
                          ? (showReadMore = true)
                          : (showReadMore = false)
                      "
                      class="view-more"
                      >{{ showReadMore ? "Ver mais " : "Ver menos" }}</span
                    >
                  </div>
                </div>
              </div>

              <div [formGroup]="formSettlement" class="card-modal">
                <div class="mb-2">
                  <h4 class="black-text anex-text">Anexar documentos</h4>
                </div>

                <ng-container>
                  <mat-tab-group
                    mat-stretch-tabs="false"
                    mat-align-tabs="start"
                    animationDuration="0ms"
                  >
                    <mat-tab label="Documentos da liquidação">
                      <div>
                        <div>
                          <ng-container
                            *ngIf="
                              !formSettlement.get('exchangeContractFile')
                                ?.value &&
                              !this.boobleModalData?.orderSettlement
                                ?.exchangeContractFile
                            "
                          >
                            <input
                              #documentFile
                              type="file"
                              id="exchangeContractFile"
                              style="display: none"
                              (input)="
                                exchangeContractFileChange(
                                  formSettlement,
                                  $event
                                )
                              "
                            />
                            <div
                              class="row d-flex row-no-file justify-content-between"
                              (click)="documentFile.click()"
                            >
                              <div class="file-no-anexado">
                                <img
                                  alt=""
                                  src="assets/image/document-add-icon.svg"
                                />
                                <p class="align-self-center title">
                                  Contrato de câmbio
                                </p>
                                <p class="format-text">
                                  Formatos aceitos .pdf .doc .png e .jpg
                                </p>
                              </div>

                              <div class="file-anexar border-grey-light">
                                <p class="p-text-grey align-self-center">
                                  <strong class="pointer">Anexar</strong>
                                </p>
                              </div>
                            </div>
                          </ng-container>

                          <ng-container
                            *ngIf="
                              !formSettlement.get('exchangeContractFile')
                                ?.value &&
                              this.boobleModalData?.orderSettlement
                                ?.exchangeContractFile
                            "
                          >
                            <div
                              class="row d-flex row-file justify-content-between"
                            >
                              <div class="file-sent">
                                <div class="img-delete">
                                  <img
                                    alt=""
                                    src="assets/image/document-icon.svg"
                                  />
                                </div>
                                <p class="p-text-grey align-self-center">
                                  {{
                                    this.boobleModalData?.orderSettlement
                                      ?.exchangeContractFile
                                  }}
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              formSettlement.get('exchangeContractFile')
                                ?.value &&
                              !this.boobleModalData?.orderSettlement
                                ?.exchangeContractFile
                            "
                          >
                            <div
                              class="row d-flex row-file justify-content-between"
                            >
                              <div class="file-anexado">
                                <div class="img-delete">
                                  <img
                                    alt=""
                                    src="assets/image/document-icon.svg"
                                  />
                                </div>
                                <p class="p-text-grey align-self-center">
                                  {{
                                    formSettlement.get("exchangeContractFile")
                                      ?.value.name
                                  }}
                                </p>
                              </div>

                              <div
                                (click)="resetControl('exchangeContractFile')"
                                class="file-removed border-grey-light"
                              >
                                <p class="text-danger align-self-center">
                                  <strong>Remover documento</strong>
                                </p>
                              </div>
                            </div>
                          </ng-container>
                        </div>

                        <div
                          *ngIf="boobleModalData.remmitanceType === 'OUTBOUND'"
                        >
                          <ng-container
                            *ngIf="
                              !formSettlement.get('swiftFile')?.value &&
                              !this.boobleModalData?.orderSettlement
                                ?.proofOperationFile
                            "
                          >
                            <input
                              #swiftFile
                              type="file"
                              id="swiftFile"
                              style="display: none"
                              (input)="swiftFileChange(formSettlement, $event)"
                            />
                            <div
                              class="row d-flex row-no-file justify-content-between"
                              (click)="swiftFile.click()"
                            >
                              <div class="file-no-anexado">
                                <img
                                  alt=""
                                  src="assets/image/document-add-icon.svg"
                                />
                                <p class="align-self-center title">Swift</p>
                                <p class="format-text">
                                  Formatos aceitos .pdf .doc .png e .jpg
                                </p>
                              </div>

                              <div class="file-anexar border-grey-light">
                                <p class="p-text-grey align-self-center">
                                  <strong class="pointer">Anexar</strong>
                                </p>
                              </div>
                            </div>
                          </ng-container>

                          <ng-container
                            *ngIf="
                              !formSettlement.get('swiftFile')?.value &&
                              this.boobleModalData?.orderSettlement
                                ?.proofOperationFile
                            "
                          >
                            <div
                              class="row d-flex row-file justify-content-between"
                            >
                              <div class="file-sent">
                                <div class="img-delete">
                                  <img
                                    alt=""
                                    src="assets/image/document-icon.svg"
                                  />
                                </div>
                                <p class="p-text-grey align-self-center">
                                  {{
                                    this.boobleModalData?.orderSettlement
                                      ?.proofOperationFile
                                  }}
                                </p>
                              </div>
                            </div>
                          </ng-container>

                          <ng-container
                            *ngIf="
                              formSettlement.get('swiftFile')?.value &&
                              !this.boobleModalData?.orderSettlement
                                ?.proofOperationFile
                            "
                          >
                            <div
                              class="row d-flex row-file justify-content-between"
                            >
                              <div class="file-anexado">
                                <div class="img-delete">
                                  <img
                                    alt=""
                                    src="assets/image/document-icon.svg"
                                  />
                                </div>
                                <p class="p-text-grey align-self-center">
                                  {{
                                    formSettlement.get("swiftFile")?.value.name
                                  }}
                                </p>
                              </div>

                              <div
                                (click)="resetControl('swiftFile')"
                                class="file-removed border-grey-light"
                              >
                                <p class="text-danger align-self-center">
                                  <strong>Remover documento</strong>
                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <div class="mb-xl-0 mb-2 toggle">
                            <div class="label">&nbsp;</div>
                            <mat-slide-toggle
                              formControlName="sendEmail"
                              color="primary"
                            >
                              <label class="square mb-0"
                                >Enviar e-mail de anexos para o cliente.
                              </label>
                            </mat-slide-toggle>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab label="Documentos da operação">
                      <div>
                        <input
                          #fileSelector
                          type="file"
                          [multiple]="true"
                          style="display: none"
                          (change)="selectFile($event)"
                        />
                        <div
                          *ngIf="selectedFiles.length == 0"
                          appDrag
                          (files)="filesDropped($event)"
                          (click)="fileSelector.click()"
                          class="row glass tappable"
                        >
                          <div class="col-12">
                            <p class="text-center upload-icon">
                              <mat-icon svgIcon="cloud-upload"></mat-icon>
                            </p>
                            <p class="upload-disclaimer text-center">
                              Arraste a ordem para cá ou
                              <span class="upload-disclaimer highlighted"
                                >busque nos seus arquivos</span
                              >
                            </p>
                            <p class="description text-center">
                              Apenas os formatos .pdf .doc .png e .jpg são
                              aceitos
                            </p>
                          </div>
                        </div>

                        <div
                          class="container-documents"
                          *ngIf="selectedFiles.length > 0"
                        >
                          <ng-container
                            *ngFor="let file of selectedFiles; let i = index"
                          >
                            <div
                              class="d-flex file-exclude justify-content-between align-items-md-center"
                            >
                              <div class="d-flex elipsis name-file-with-icon">
                                <img src="assets/image/clip-icon.svg" />

                                <span
                                  class="black-text name-file"
                                  [matTooltip]="file.file.name"
                                  >{{ file.file.name }}</span
                                >
                              </div>

                              <div
                                class="d-flex btn-delete-file"
                                (click)="removeFile(i)"
                              >
                                <span class="blue-text">Excluir</span>

                                <img src="assets/image/trash-icon.svg" />
                              </div>
                            </div>
                          </ng-container>

                          <div class="d-flex justify-content-center mt-3">
                            <span
                              class="btn-blue"
                              (click)="fileSelector.click()"
                              >Adicionar mais documentos</span
                            >
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="buttons">
            <button
              class="mb-3 btn btn-dark-primary-outline-back"
              (click)="closeModal()"
              type="button"
            >
              Fechar
            </button>

            <!-- <button
            class="btn mb-3 btn-dark-primary-blue"
            [disabled]="
              this.boobleModalData?.orderSettlement?.exchangeContractFile
                ? this.selectedFiles?.length == 0 || loading
                : formSettlement?.invalid || loading
            "
            type="button"
            (click)="settlementConfirm()"
          >
            Salvar
          </button> -->
            <button
              class="btn mb-3 btn-dark-primary-blue"
              [disabled]="
                this.boobleModalData?.orderSettlement?.exchangeContractFile
                  ? this.selectedFiles?.length == 0 || loading
                  : loading
              "
              type="button"
              (click)="settlementConfirm()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
